import { render, staticRenderFns } from "./Consumo.vue?vue&type=template&id=3184bb6e&"
import script from "./Consumo.vue?vue&type=script&lang=js&"
export * from "./Consumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports